<template>
  <v-row
      align="center"
      justify="center"
  >
    <v-col>
      <v-card
          shaped
          elevation="5"
      >
        <v-card-title
          class="text-h4 justify-center"
        >
          علم الاعداد کا حساب کتاب
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
                cols="12"
                sm="4"
            >
              <InputComponent
                  :inputs="inputs"
                  inputName="momName"
                  label="ماں کا نام"
                  @onInputFocus="onInputFocus"
                  @onInputChange="onInputChange"
              />
            </v-col>
            <v-col
                cols="12"
                sm="4"
            >
              <InputComponent
                  :inputs="inputs"
                  inputName="babyName"
                  label="بچے کا نام"
                  @onInputFocus="onInputFocus"
                  @onInputChange="onInputChange"
              />
            </v-col>
            <v-col
                cols="12"
                sm="4"
            >
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      outlined
                      v-model="picker"
                      label="تاریخ پیدائش"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  />
                </template>
                <v-date-picker
                    v-model="picker"
                    first-day-of-week="1"
                    locale="ur-PK"
                    @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row
            align="center"
          >
            <v-col
                cols="12"
                sm="4"
            >
              <v-alert
                  elevation="5"
                  shaped
                  type="info"
                  color="teal"
                  class="text-center"
                  v-html="babySentence"
              />
            </v-col>
            <v-col
                cols="12"
                sm="4"
            >
              <v-alert
                  elevation="10"
                  shaped
                  type="info"
                  color="cyan lighten-1"
                  class="text-center"
                  v-html="resultSentence"
              />
            </v-col>
            <v-col
                cols="12"
                sm="4"
            >
              <v-alert
                  elevation="5"
                  shaped
                  type="info"
                  color="teal"
                  class="text-center"
                  v-html="dobSentence"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <SimpleKeyboard
              :key="$vuetify.theme.dark"
              @onChange="onChange"
              :input="inputs[inputName]"
              :inputName="inputName"
              dir="ltr"
          />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SimpleKeyboard from "../components/SimpleKeyboard.vue"
import InputComponent from "../components/InputComponent.vue";
import "../styles/App.css"

export default {
  name: "NameView",
  components: {
    SimpleKeyboard,
    InputComponent
  },
  data: () => ({
    inputs: {
      momName: "",
      babyName: ""
    },
    inputName: "momName",
    momSum: 0,
    babySum: 0,
    picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
  }),
  computed: {
    momName() {
      return this.inputs.momName
    },
    babyName() {
      return this.inputs.babyName
    },
    dobSentence() {
      return "تاریخ کا ستارہ " + "&ensp; --- &ensp;" + this.getStar(this.getStarNumber())
    },
    babySentence() {
      return (this.babyName === "" || this.momName === "") ? "ماں اور بچے کا نام تحریر کریں" : "نام کا ستارہ" + "&ensp; --- &ensp;" + this.getStar(this.getNameNumber())
    },
    resultSentence() {
      return (this.babyName === "" || this.momName === "") ? "تمام معلومات فراہم کریں" : this.getConflictInfo(this.getStar(this.getStarNumber()), this.getStar(this.getNameNumber()))
    }
  },
  watch: {
    momName() {
      this.calcMomName()
    },
    babyName() {
      this.calcBabyName()
    }
  },
  methods: {
    /*
    Keyboard Related
    */
    onChange(input) {
      this.inputs[this.inputName] = input;
    },
    onInputChange(input) {
      this.inputs[input.target.id] = input.target.value;
    },
    onInputFocus(input) {
      this.inputName = input.target.id;
    },

    /*
    Input/Numbers Related
    */
    getVal(val) {
      if(val === 'ا') return 1
      else if(val === 'ب') return 2
      else if(val === 'ج') return 3
      else if(val === 'د') return 4
      else if(val === 'ہ') return 5
      else if(val === 'ھ') return 5
      else if(val === 'و') return 6
      else if(val === 'ز') return 7
      else if(val === 'ح') return 8
      else if(val === 'ط') return 9
      else if(val === 'ى') return 10
      else if(val === 'ے') return 10
      else if(val === 'ک') return 20
      else if(val === 'ل') return 30
      else if(val === 'م') return 40
      else if(val === 'ن') return 50
      else if(val === 'س') return 60
      else if(val === 'ع') return 70
      else if(val === 'ف') return 80
      else if(val === 'ص') return 90
      else if(val === 'ق') return 100
      else if(val === 'ر') return 200
      else if(val === 'ش') return 300
      else if(val === 'ت') return 400
      else if(val === 'ث') return 500
      else if(val === 'خ') return 600
      else if(val === 'ذ') return 700
      else if(val === 'ض') return 800
      else if(val === 'ظ') return 900
      else if(val === 'غ') return 1000
      else if(val === 'پ') return 2
      else if(val === 'چ') return 300
      else if(val === 'ڈ') return 4
      else if(val === 'گ') return 1000
      else if(val === 'ڑ') return 2000
      else if(val === 'ں') return 50
      else if(val === 'ء') return 1
      else return 0
    },
    getStar(val) {
      if (val === 1) return "حمل"
      else if (val === 2) return "ثور"
      else if (val === 3) return "جوزا"
      else if (val === 4) return "سرطان"
      else if (val === 5) return "اسد"
      else if (val === 6) return "سنبلہ"
      else if (val === 7) return "میزان"
      else if (val === 8) return "عقرب"
      else if (val === 9) return "قوس"
      else if (val === 10) return "جدی"
      else if (val === 11) return "دلو"
      else if (val === 0 || val === 12) return "حوت"
      else return "برج کی غلطی"
    },
    getStarNumber() {
      let x = new Date(this.picker)
      if(x.getMonth() === 2) return (x.getDate() >= 21) ? 1 : 12
      else if(x.getMonth() === 3) return (x.getDate() >= 21) ? 2 : 1
      else if(x.getMonth() === 4) return (x.getDate() >= 22) ? 3 : 2
      else if(x.getMonth() === 5) return (x.getDate() >= 23) ? 4 : 3
      else if(x.getMonth() === 6) return (x.getDate() >= 24) ? 5 : 4
      else if(x.getMonth() === 7) return (x.getDate() >= 24) ? 6 : 5
      else if(x.getMonth() === 8) return (x.getDate() >= 24) ? 7 : 6
      else if(x.getMonth() === 9) return (x.getDate() >= 24) ? 8 : 7
      else if(x.getMonth() === 10) return (x.getDate() >= 23) ? 9 : 8
      else if(x.getMonth() === 11) return (x.getDate() >= 21) ? 10 : 9
      else if(x.getMonth() === 0) return (x.getDate() >= 20) ? 11 : 10
      else if(x.getMonth() === 1) return (x.getDate() >= 19) ? 12 : 11
      else return -1
    },
    getNameNumber() {
      return (this.babySum + this.momSum) % 12
    },
    getGroup(val) {
      if (val === "حمل") return "آتشی"
      else if (val === "ثور") return "خاکی"
      else if (val === "جوزا") return "بادی"
      else if (val === "سرطان") return "آبی"
      else if (val === "اسد") return "آتشی"
      else if (val === "سنبلہ") return "خاکی"
      else if (val === "میزان") return "بادی"
      else if (val === "عقرب") return "آبی"
      else if (val === "قوس") return "آتشی"
      else if (val === "جدی") return "خاکی"
      else if (val === "دلو") return "بادی"
      else if (val === "حوت") return "آبی"
      else return "غلطی"
    },

    getConflictInfo(dob, name) {
      let x = this.getGroup(dob)
      let y = this.getGroup(name)
      if(dob === name) {
        return "Ideal"
      }
      else {
        if (x === y) return "دونوں برج کے مزاج " + x + " ہے۔ اس لیے یہ نام مناسب ہے"
        else if (((x === "آتشی" && y === "بادی") || (x === "بادی" && y === "آتشی")) || ((x === "آبی" && y === "خاکی") || (x === "خاکی" && y === "آبی"))) return dob + " کا مزاج " + x + " اور " + name + " کا مزاج " + y + " ہوتا ہے۔ اور ان میں دوستی ہوتی ہے۔ الغرض یہ نام مناسب ہے۔"
        else if (((x === "آتشی" && y === "آبی") || (x === "آبی" && y === "آتشی")) || ((x === "بادی" && y === "خاکی") || (x === "خاکی" && y === "بادی"))) return dob + " کا مزاج " + x + " اور " + name + " کا مزاج " + y + " ہوتا ہے۔ اور ان میں دشمنی ہوتی ہے۔ الغرض یہ نام مناسب نہیں ہے۔"
        else return dob + " کا مزاج " + x + " اور " + name + " کا مزاج " + y + " ہوتا ہے۔ اور ان میں نہ دوستی ہوتی ہے اور نہ دشمنی ہوتی ہے۔ الغرض یہ نام معقول ہے۔"
      }
    },
    /*getNum(val) {
      let sum = 0
      while (val > 0) {
        let x = val % 10
        val = parseInt(val / 10)
        sum += x
      }
      if (sum === 10) sum = 1
      else if (sum > 10) sum = this.getNum(sum)

      return sum
    },*/
    calcMomName() {
      this.momSum = 0
      for (let i in this.momName) {
        this.momSum += this.getVal(this.momName[i])
      }
    },
    calcBabyName() {
      this.babySum = 0
      for (let i in this.babyName) {
        this.babySum += this.getVal(this.babyName[i])
      }
    },
  },
}
</script>